<template>
  <div class="formCom">
    <div class="form" >
      <button class="close" @click="closeModal">
        <CloseIcone></CloseIcone>
      </button>
      <div class="name">
        Edit Inventory
      </div>
      <div class="label-name">Unit Price</div>
      <div class="input-wrap" >
        <input
          type="text"
          class="input toLowerCase"
          placeholder="Unit Price (e.g. 0.00)"
          v-model="units_per_price"
          @input="clearValidate"
          :class="{ invalid: errors.has('units_per_price') }"
          name="units_per_price"
          v-validate="'decimal'"
        />
        <span class="validate-error" v-if="errors.has('units_per_price')">
          {{ errors.first("units_per_price") }}
        </span>
      </div>
      <div class="label-name">Available Inventory</div>
      <div class="input-wrap">
        <input
          type="text"
          class="input"
          :class="{ invalid: errors.has('available_inventory'), 'read-only-input': isWestLocation }"
          placeholder="Available Inventory"
          v-model="available_inventory"
          name="available_inventory"
          :disabled="isWestLocation"
          :readonly="isWestLocation"
          v-validate="isWestLocation ? '' : 'required|numeric|max:10'"
        />
        <span class="validate-error" v-if="errors.has('available_inventory')">
          {{ errors.first("available_inventory") }}
        </span>
        <span class="west-lock-note" v-if="isWestLocation">
          🔒 Inventory for West location is read-only.
        </span>
      </div>
      <button
        class="btn"
        @click.prevent="$validator.validateAll()"
        @click="editSave"
      >
        Submit
      </button>
      <div class="txt">{{ txt }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import CloseIcone from "../../../images/shared/cancel";

export default {
  name: "EditInventory",
  props:['item'],
  data() {
    return {
      units_per_price: null,
      available_inventory: null,
      txt: null,
      locations: []
    };
  },
  components: {
    CloseIcone
  },
  methods: {
    clearValidate() {
      this.errors.clear();
      this.clearServerValidationErrors();
    },
    ...mapMutations(["clearServerValidationErrors"]),
    ...mapActions(["editInv", "getAdminInfoList", "handleErrors"]),
    closeModal() {
      this.errors.clear();
      this.clearServerValidationErrors();
      this.$emit("closeModal", false);
    },
    editSave() {
      if (this.errors.any()) {
        return;
      } else {
        const val = this.units_per_price;
        const formattedPrice = (val !== null && val !== undefined && val !== '' && !isNaN(parseFloat(val)))
          ? parseFloat(val).toFixed(2)
          : '0.00';
        this.item.units_per_price = formattedPrice;
        if (!this.isWestLocation) {
          this.item.available_inventory = this.available_inventory;
        }
        this.editInv(this.item)
          .then(res => {
            this.errors.clear();
            this.clearServerValidationErrors();
            this.txt = "Item successfully Updated";
          })
          .catch(err => {
            this.handleErrors({
              errors: [
                {
                  field: "email_admin",
                  message: "Error updating inventory"
                }
              ]
            });
          });
      }
    }
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return this.form.email && this.form.first_name && this.form.last_name;
    },
    isWestLocation() {
      if (!this.item) return false;
      const locStr = String(
        this.item.location || this.item.location_name || ""
      ).toLowerCase();
      if (locStr.includes("west")) return true;

      const locId = this.item.location_id != null ? this.item.location_id : (this.item.loc_id != null ? this.item.loc_id : null);
      if (locId != null && Array.isArray(this.locations)) {
        const found = this.locations.find(l => String(l.id) === String(locId));
        if (found && String(found.location || "").toLowerCase().includes("west")) {
          return true;
        }
      }
      return false;
    }
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  },
  mounted(){
      this.locations = this.$store.getters.getLocation || [];
      const price = this.item.units_per_price;
      this.units_per_price = (price !== null && price !== undefined && price !== '' && !isNaN(parseFloat(price)))
        ? parseFloat(price).toFixed(2)
        : '0.00';
      this.available_inventory = this.item.available_inventory;
  }
};
</script>

<style scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}
.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}
.input.invalid {
  border: 1px solid red;
}
.form {
  padding: 30px;
  background-color: #fff;
  max-width: 350px;
  width: 100%;
  position: relative;
  z-index: 1;
}
.input-wrap {
  width: 100%;
  margin: 0 0 15px 0;
}
.input {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 15px 20px;
  color: #4d4d4d;
  width: 100%;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
  text-align: center;
  outline: none;
}
.input::placeholder {
  color: #98a4ae;
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.select {
  height: 45px;
  background-color: #fff;
  color: #98a4ae;
  text-align-last: center;
}
.btn {
  background-color: #6cc24a;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}
.btn.change {
  height: auto;
  width: auto;
  margin: 10px auto 0 auto;
  border-radius: 0px;
  padding: 0;
  color: #6cc24a;
  background-color: transparent;
}
.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #6cc24a;
}
.btn:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}
.btn.change:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid transparent;
}
.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 30px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.label-name {
  color: #005eb8;
  font-size: 14px;
  margin: 0 0 10px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.txt {
  color: green;
  font-size: 14px;
  margin: 15px 0 0px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}
.read-only-input {
  background-color: #f1f5f9 !important;
  color: #64748b !important;
  cursor: not-allowed !important;
  border-color: #cbd5e1 !important;
}
.west-lock-note {
  font-size: 11px;
  color: #64748b;
  margin-top: 4px;
  display: block;
  text-align: center;
}
.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  text-align: center;
  
  }
</style>
